export default "__VITE_ASSET__65Oyt8If__"